import {
    LOAD_LOYALTY_USERS,
    CLEAR_LOYALTY_USERS
} from '../../../actions/types';

const INITIAL_STATE = {
    content: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOAD_LOYALTY_USERS:
            return action.payload;
        case CLEAR_LOYALTY_USERS:
            return INITIAL_STATE;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/restaurants/loyalty/LoyaltyUsersReducer.js